import React from 'react';
import './NotFound.css';
import Localize from "../../components/Localize/Localize";
import LocalizeKeys from "../../components/Localize/LocalizeKeys";
import NavBar from "../NavBar/NavBar";

function NotFound() {
  return (
    <div>
    <NavBar />
    <div className="nf-container">
      <div className="nf-image-col">
        <img
          src="/M_cash_app_logo.png"
          alt="Mundigames Cash"
          className="nf-logo"
        />
      </div>
      <div className="nf-content-col">
        <h1 className="nf-title">{Localize.translate(LocalizeKeys.NOT_FOUND_TITLE)}</h1>
        <p className="nf-body">{Localize.translate(LocalizeKeys.NOT_FOUND_MESSAGE)}</p>
        <a href="/" className="nf-btn">{Localize.translate(LocalizeKeys.NOT_FOUND_BUTTON)}</a>
      </div>
    </div>
    </div>
  );
}

export default NotFound;
